export const GET_MODE = "GET_MODE";
export const SET_MODE = "SET_MODE";
